<template>
  <div class="home">
    <div class="content">
      <div class="img"><img src="../assets/logo.png" alt=""></div>
      <div class="title1">SPECIALIST COMPRESSOR</div>
      <div class="title2">MANUFACTURERS</div>
      <div class="btn"><el-button type="warning" plain @click="toAboutPage">LEARN MORE SYNERGY</el-button></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
       
    };
  },
  mounted() {
    
  },
  methods: {
    //调用loading
    loadingBtn() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
    },
    toAboutPage(){
      this.$router.push('/about')
    }
  },
  created() {},
};
</script>

<style scoped>
.home {
  font-size: 14px;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: 100vh;
  background-image: url(../assets/bg1.png);
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  text-align: center;
}
.content .img img {
  width: 100%;
  padding-bottom: 20px;
}
.content .title1, .title2{
  font-family: 'EthnocentricRg';
  font-size: 28px;
  letter-spacing: 2px; /* 增加字母间距 */
  color: #ffc000;
}
.content .btn {
  padding-top: 20px;
  
}
.el-button--warning.is-plain {
  font-size: 18px;
  line-height: 35px;
  border-radius: 10px;
  border: 1.5px solid #ffc000;
  color: #ffc000;
  background: rgba(0,0,0,0);
}
.el-button--warning.is-plain:focus, .el-button--warning.is-plain:hover {
  background: #e3770a;
  border-color: #e3770a;
  color: #FFF;
}

/* #ffc000 */

</style>
